module.exports = __webpack_public_path__ + "img/ressource-05.5abef5a9.svg";